var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledSuccessTickWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 20,
    rx: 10.25,
    ry: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8386 16.0083L20.0349 26.0083C19.7138 26.42 19.2166 26.6633 18.6871 26.6667H18.6751C18.1506 26.6667 17.6552 26.43 17.3306 26.0267L13.176 20.8483C12.5951 20.125 12.725 19.0767 13.4681 18.51C14.2095 17.9417 15.2858 18.0683 15.8666 18.795L18.6563 22.2717L25.1206 13.99C25.6912 13.2583 26.7623 13.115 27.5157 13.6733C28.2657 14.2317 28.4109 15.2767 27.8386 16.0083ZM3.41797 20C3.41797 29.2033 11.0662 36.6667 20.5013 36.6667C29.9364 36.6667 37.5846 29.2033 37.5846 20C37.5846 10.795 29.9364 3.33334 20.5013 3.33334C11.0662 3.33334 3.41797 10.795 3.41797 20Z",
    fill: "#1B8828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledSuccessTickWhite);
export default __webpack_public_path__ + "static/media/icon-filled-success-tick-white.ac3bedeae1542853de86ef5eb40cdbc3.svg";
export { ForwardRef as ReactComponent };